module.exports = __webpack_public_path__ + "static/icba-logo-banner-a98389c6d39ab9a3ae931b24f0df98bc.png";